module.exports = __webpack_public_path__ + "static/media/emotionsc2915c94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/emotions.svg
// module id = 1326
// module chunks = 0